import API from '../../../lib/commons/api'

export type DivisionDto = {
  uuid: string
  displayName: string
  officialName: string
}

// Fetch-all uses a high limit so every record comes back in a single request.
const FIND_ALL_LIMIT = 2000

export const findDivisions = async (): Promise<DivisionDto[]> => {
  const response = await API.functional.request(
    'GET',
    '/api/v1/divisions/find',
    { name: '', limit: FIND_ALL_LIMIT },
    true
  )
  return (response.json?.data ?? []) as DivisionDto[]
}
